module.exports = __webpack_public_path__ + "img/4.ad59a58f.jpg";